import { createContext, useContext } from "react";

export interface PdfDownloadModalContextValue {
  showModal: (confirmCallback: () => void) => void;
  hideModal: () => void;
}

export const PdfDownloadModalContext =
  createContext<PdfDownloadModalContextValue | null>(null);

export function usePdfDownloadModal(): PdfDownloadModalContextValue {
  const context = useContext(PdfDownloadModalContext);
  if (!context) {
    throw new Error(
      "usePdfDownloadModal must be used within a PdfDownloadModalProvider",
    );
  }
  return context;
}
